module.exports = __webpack_public_path__ + "img/5.422acd45.png";